<template>
    <el-dialog :visible="visible" :modal-append-to-body="false" class="invoice-files-edit-dialog ah-detail-dialog" top="6vh" append-to-body :lock-scroll="false" @open="onOpen" @close="onClose()">
        <template slot="title">
            <span>編輯文件</span>
        </template>
        <ahUploader ref="ahUploader" @change="onChangeAttachment" />
        <div class="receipt-modal-layout">
            <div v-if="receiptModal.fileExt == 'jpg' || receiptModal.fileExt == 'jpeg' || receiptModal.fileExt == 'png'" class="image-block">
                <el-image v-if="form.filE_ATT" style="width: 100%" :src="form.filE_ATT" :previewSrcList="[form.filE_ATT]"></el-image>
                <div style="text-align: center; margin: 12px 0">
                    <el-button size="small" @click="onReplaceAttachment">
                        更換檔案
                    </el-button>
                </div>
            </div>
            <div class="file-block" v-else-if="receiptModal.fileExt == 'pdf'">
                <div class="file">
                    <ahFileIcon :ext="receiptModal.fileExt" :url="form.filE_ATT" />
                </div>
                <div style="text-align: center; margin: 12px 0">
                    <el-button size="small" @click="onReplaceAttachment">
                        更換檔案
                    </el-button>
                </div>
            </div>
            <div v-else class="file-block" style="text-align: center">
                <ahQrCodeUploader :visible="!receiptModal.fileExt" @change="onQrCodeAttChange" />
                <div class="or">or</div>
                <div style="text-align: center; margin: 12px 0">
                    <el-button size="small" @click="onUploadFile">
                        上傳檔案 (圖片、PDF檔)
                    </el-button>
                    <div style="font-size: 12px; color: #aaa; margin-top: 3px">(檔案大小上限：25MB)</div>
                </div>
            </div>
            <div class="form-block">
                <el-form ref="form" :model="form" :rules="rules" :label-position="isMobile() ? 'top' : 'right'" label-width="130px" v-loading="isLoading" @submit.native.prevent>
                    <el-form-item prop="nam" label="文件名稱">
                        <el-input v-model="form.nam" :maxlength="30" :show-word-limit="true" />
                    </el-form-item>
                    <el-form-item prop="note" label="備註">
                        <el-input v-model="form.note" :maxlength="100" :show-word-limit="true" :rows="4" type="textarea" />
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="detail-row footer">
            <div style="text-align: center">
                <el-button v-if="form.sno" type="danger" @click="onRemove" :loading="isDeleting">
                    刪除
                </el-button>
                <el-button @click="onClose()">取消</el-button>
                <el-button type="primary" @click="onSubmit">
                    儲存
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import ahUploader from '@/components/ui/Uploader/ahUploader.vue';
import ahFileIcon from '@/components/ui/ahFileIcon.vue';
import ahQrCodeUploader from '@/components/ui/ahQrCodeUploader.vue';

export default {
    props: {
        visible: Boolean,
        createMode: Boolean,
        invoiceSno: Number,
        editForm: {
            type: Object,
            default: () => {},
        },
    },
    components: { ahUploader, ahFileIcon, ahQrCodeUploader },
    data() {
        return {
            isLoading: false,
            isDeleting: false,
            uploaderVisible: false,
            receiptModal: {
                visible: false,
                dataSource: null,
                fileExt: null,
            },

            form: {
                sno: null,
                nam: null, // 摘要
                filE_ATT: null, // 檔案
                note: null, // 備註
            },
            rules: {
                nam: [{ required: true, message: '請輸入文件名稱', trigger: 'blur' }],
            },
        };
    },
    computed: {
        userName() {
            return this.$store.getters['account/userName'];
        },
    },
    methods: {
        onOpen() {
            if (this.editForm) {
                this.form.sno = this.editForm.sno;
                this.form.nam = this.editForm.nam;
                this.form.filE_ATT = this.editForm.filE_ATT;
                this.form.note = this.editForm.note;
                this.receiptModal.fileExt = this.form.filE_ATT
                    .split('.')
                    .pop()
                    .toLowerCase();
            } else {
                this.receiptModal.fileExt = null;
            }
        },
        onClose(reload) {
            this.form = {
                sno: null,
                nam: null, // 摘要
                filE_ATT: null, // 檔案
                note: null, // 備註
            };
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
            this.$emit('close', reload);
        },
        onChangeAttachment(receiptData) {
            // apply data
            if (receiptData) {
                _.forEach(receiptData, (value, key) => {
                    if (value) this.form[key] = value;
                });

                // fileType
                if (receiptData.filE_ATT && receiptData.filE_ATT?.trim() !== '') {
                    this.receiptModal.fileExt = receiptData.filE_ATT
                        .split('.')
                        .pop()
                        .toLowerCase();
                    console.log('fileExt', this.receiptModal.fileExt);
                } else {
                    this.receiptModal.fileExt = null;
                }
            }
        },
        onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    if (!this.form.filE_ATT) {
                        this.$message({
                            showClose: true,
                            message: '請至少上傳圖片或文件',
                            type: 'error',
                        });
                        return false;
                    }

                    if (this.createMode) {
                        this.$emit('create', {
                            ...this.form,
                            invoiceSno: null,
                            updateUser: this.userName,
                            updateTime: Number(
                                moment()
                                    .startOf('day')
                                    .format('x'),
                            ),
                        });
                        this.onClose();
                        return true;
                    }

                    try {
                        await this.$api({
                            url: '/InvoiceManagemnetPage/UpsertInvoiceFiles',
                            method: 'POST',
                            data: {
                                invoiceFiles: [
                                    {
                                        invoiceSno: this.invoiceSno,
                                        ...this.form,
                                    },
                                ],
                            },
                        });
                        this.onClose(true);
                    } catch (e) {
                        console.log(e);
                    }
                }
                return true;
            });
        },
        async onRemove() {
            try {
                await this.$confirm('確定要刪除此文件？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });
                if (this.createMode) {
                    this.$emit('remove', this.form.sno);
                    this.$emit('close');
                    return;
                }
                await this.$api({
                    url: '/InvoiceManagemnetPage/CancelInvoiceFiles',
                    method: 'POST',
                    data: { sno: this.form.sno },
                });
                this.onClose(true);
            } catch (e) {
                console.log(e);
            }
        },
        onQrCodeAttChange(url) {
            this.receiptModal.fileExt = url
                .split('.')
                .pop()
                .toLowerCase();
            this.form.filE_ATT = url;
        },

        onUploadFile() {
            this.$refs.ahUploader.onUploadFile();
        },
        onReplaceAttachment() {
            this.receiptModal.fileExt = null;
        },
    },
};
</script>

<style lang="scss" scoped>
.button-set {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    padding: 20px;
}
</style>

<style lang="scss">
.invoice-files-edit-dialog {
    padding: 0 10px;

    .el-dialog {
        max-width: 1300px;
        min-height: 300px;
    }

    &.file {
        .el-dialog {
            max-width: 830px;
        }
    }
    .receipt-modal-layout {
        display: block;
        width: 100%;

        @media (min-width: 992px) {
            display: table;
        }

        .file-block {
            display: block;
            height: 100%;
            background-color: #f6f6f6;
            padding: 25px;

            @media (min-width: 992px) {
                display: table-cell;
                vertical-align: top;
                height: 100%;
                position: relative;
                vertical-align: middle;
            }
        }

        .image-block {
            display: block;
            background-color: #f6f6f6;
            padding: 25px;

            @media (min-width: 992px) {
                display: table-cell;
                vertical-align: top;
                height: 100%;
                position: relative;
                vertical-align: middle;
            }

            .el-image {
                img {
                    object-fit: contain;
                    max-height: 500px;
                }
            }
        }

        .form-block {
            display: block;
            padding: 25px;
            width: 550px;

            @media (max-width: 720px) {
                width: 100%;
            }

            @media (min-width: 992px) {
                display: table-cell;
                vertical-align: top;
            }
        }
    }
    .or {
        margin: 0 auto;
        color: #888;
        font-size: 10pt;
        // border-top: 1px solid #ccc;
        max-width: 200px;
    }
}
</style>
